import styled from 'styled-components';

// Components
import {Icon} from '@drivesally/sally-ui';

const SearchIcon = styled(Icon)``;

export default SearchIcon;
